export const PROFILE_MENU_ITEM_VARIANT_DEFAULT = 'default';
export const PROFILE_MENU_ITEM_VARIANT_DANGER = 'danger';

export type ProfileMenuItemVariant =
  | typeof PROFILE_MENU_ITEM_VARIANT_DEFAULT
  | typeof PROFILE_MENU_ITEM_VARIANT_DANGER;
